import { render, staticRenderFns } from "./SendCertificate.vue?vue&type=template&id=7bae54a8&scoped=true"
import script from "./SendCertificate.vue?vue&type=script&lang=ts"
export * from "./SendCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bae54a8",
  null
  
)

export default component.exports